import React from 'react'
import PaginaPorDefecto from './Default'

export default function Prueba() {
  return (
    <PaginaPorDefecto titulo='Esta Pagina es de prueba'>
      <div>Soy la pagina de prueba</div>
    </PaginaPorDefecto>
  )
}
